const snackbarContentCustomTypes = {
    success: {
        value: 'success',
        message: 'Enregistrement effectué avec succès.',
    },
    error: {
        value: 'error',
        message: 'Des erreurs sont survenues pendant l\'enregistrement.',
    },
    info: {
        value: 'info',
        message: ''
    },
    warning: {
        value: 'warning',
        message: ''
    },
}

export default snackbarContentCustomTypes;


// WEBPACK FOOTER //
// ./src/components/custom/snackbar/SnackbarContentCustomTypes.js